import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';

import {Quiz, QuizOption} from '../quiz';

@Component({
  selector: 'fllt-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements AfterViewInit {
    @Input() quiz: Quiz;
    @Output() ended = new EventEmitter();

    public instructionsShown = false;

    ngAfterViewInit() {
        this.doPositioning();
    }

    begin() {
        this.instructionsShown = true;
        setTimeout(this.doPositioning, 0);
    }

    select(option: QuizOption) {
        this.quiz.answer(option);
        if (this.quiz.ended) {
            this.ended.emit();
        }
    }

    get percentage(): string {
        return Math.round((this.quiz.current - 1) / this.quiz.count * 100) + '%';
    }

    private doPositioning() {
        try {
            const height = window.innerHeight;
            const page: any = document.querySelector('article#question-page');
            page.style.height = height + 'px';
            const box: any = document.querySelector('.question-container');
            box.style.marginTop = height / 4 + 'px';
        } catch (e) {}
    }
}



// WEBPACK FOOTER //
// ./src/app/question/question.component.ts